import { defineComponent as _defineComponent } from 'vue'
import ActionModal from 'JS/components/modals/ActionModal.vue';
import BButton from 'JS/components/BButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalErrorModal',
  props: {
    message: null,
    hideRestartOption: { type: Boolean }
  },
  setup(__props: any) {



function reload() {
	window.location.reload();
}

return { __sfc: true,reload, ActionModal, BButton }
}

})